import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
var cors = require('cors');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

